import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Message } from '@independent-software/typeui/controls/Message';
import { Placeholder } from '@independent-software/typeui/controls/Placeholder';

import { AuthContext } from '../../AuthContext';
import { Query } from '../../services';
import { Container, Content, BottomBar, Section } from '../../modules';
import { Stationcategory, StationcategoryFactory } from '../../resource/';
import { CategoryTree } from '../../controls/CategoryTree';

const StationcategoryList = () => {
  const auth = React.useContext(AuthContext);
  const navigate = useNavigate();

  const [stationcategories, setStationcategories] = React.useState([] as Stationcategory[]);

  React.useEffect(() => {
    // Retrieve a list of stationcategories:
    let query = new Query('name', 'asc');
    StationcategoryFactory.getSome(auth, 0, 999, query)
      .then((res) => setStationcategories(res.items));
  }, []);

  const handleClick = (item: Stationcategory) => {
    navigate(`/stationcategories/${item.id}`);
  }

  const handleAdd = (item: Stationcategory, name: string) => {
    let cat = StationcategoryFactory.create();
    cat.parent = item ? item.id : null;
    cat.name = name;
    cat.$save(auth)
    .then(res => {
      ToastService.toast("Station category created.");
      cat.id = res.data;
      setStationcategories([ ...stationcategories, cat ]);
    });
  }

  const handleEdit = (item: Stationcategory, name: string) => {
    item.name = name;
    item.$update(auth)
    .then(_ => {
      ToastService.toast("Station category updated.");
    });    
  }
  
  const handleDelete = (item: Stationcategory) => {
    let idx = stationcategories.indexOf(item);
    stationcategories.splice(idx, 1);
    setStationcategories(stationcategories);
    item.$delete(auth)
    .then(_ => {
      ToastService.toast("Station category deleted.");
    });        
  }

  return (
    <Container>
      <Content>
        <Section padded="very">
          {stationcategories == null && <>
            <Placeholder>
              <Placeholder.Header image>
                <Placeholder.Line tall/>
                <Placeholder.Line tall/>
              </Placeholder.Header>
            </Placeholder>
          </>}
          {stationcategories != null && 
            <>
            {stationcategories.length == 0 && 
              <Message type="info">
                No station categories have been defined yet.
              </Message>}            
            <CategoryTree 
              items={stationcategories} 
              onClick={handleClick}
              onAdd={auth.hasRight('can_edit_stationcategories') && handleAdd} 
              onEdit={auth.hasRight('can_edit_stationcategories') && handleEdit} 
              onDelete={auth.hasRight('can_delete_stationcategories') && handleDelete}
              countfield="stations_count"
              />
            </>}
        </Section>
      </Content>
      <BottomBar>
      </BottomBar>
    </Container>
  );
}

export { StationcategoryList }
